/**
 * Redirect if authenticated.
 */

export default function({ to, from, store }) {
    if (store.getters.apiKey) {
        return {
            name: `${to.name}-unlock`,
            params: to.params,
        };
    }
}
